import React, { Component, Fragment } from 'react';
import { PulseLoader, BarLoader } from 'react-spinners';
import axios from 'axios';
import ResourceItem from './ResourceItem';
import ResourceFilter from './ResourceFilter';

const API_URL = process.env.REACT_APP_API_URL+'api/resources';
const ORG_API_URL = process.env.REACT_APP_API_URL+'api/organisations';
const INITIAL_STATE = {
	resources: [],
	next_page: API_URL,
	loading: false,
	init_load_more: false,
	pagination: [],
	resource: {
		title: '',
		type: 0,
		organisation_title: '',
		artsmark_partner: 0,
		support_send: 0,
		keystages: [],
		artform: 0,
		status: 'active',
		sort: 'submitted',
		page: 1
	}
};

class ResourceSearchList extends Component {
	state = INITIAL_STATE;

	componentDidMount() {
		this.resourceFilter = React.createRef();
		
		if (this.props.id && !this.state.loading) {

			this.setState({
				loading: true
			});

			axios.get(ORG_API_URL+'/'+this.props.id)
				.then(response => {
					let orgTitle = response.data.data.title;

					console.log(response)

					this.setState(
						prevState => ({
							resource: {
								organisation_title: orgTitle,
								visible: 1,
								status: 'active'
							},
							loading: false,
						}), () => console.log(this.state)
					);

					this.getFilteredResults();
				});
		} else {
			this.init();
		}
	}

	init() {
		if(!this.state.loading) {
			this.setState({
				loading: true
			});

			axios.get(this.state.next_page)
				.then(response => {
					const paginator = response.data.meta.pagination;
					const resources = response.data.data;

					if(resources.length){
						this.setState({
							resources: [...this.state.resources, ...resources],
							next_page: paginator.links.next,
							loading: false
						});					
					}

					if(paginator.links.next){
						this.setState({ init_load_more: true });
					}
				});
		}
	}

	onClearFilter = () => {
		this.setState(INITIAL_STATE, () => {
			this.init();
			this.resourceFilter.current.getArtformTypes();
		});
	};

	onFilteredResults = (props) => {


		//console.log(props);

		this.setState(INITIAL_STATE, () => {
			this.init();
			this.resourceFilter.current.getArtformTypes();
		});


		this.setState({
			resources: [],
			init_load_more: false,
			resource: {
				title: props.resource.title,
				type: props.resource.type,
				organisation_title: props.resource.organisation_title,
				support_send: props.resource.support_send,
				keystages: props.resource.keystages,
				artform: props.resource.artform,
				sort: props.resource.sort,
				status: props.resource.status,
				page: props.page,				
			}
		}, () => this.getFilteredResults()
		);
	}

	getFilteredResults = () => {
		console.log(this.state);

		

		axios.post(API_URL+'/filter', {
			title: this.state.resource.title,
			type: this.state.resource.type,
			organisation_title: this.state.resource.organisation_title,
			support_send: this.state.resource.support_send,
			keystages: this.state.resource.keystages,
			artform: this.state.resource.artform,
			sort: this.state.resource.sort,
			status: this.state.resource.status,
			page: this.state.resource.page,
			visible: this.state.resource.visible
		})
		.then(response => {
			const resources = response.data.data;
			const pagination = response.data.meta.pagination;

			if (this.state.pagination.total_pages > this.state.pagination.current_page) {
				this.setState({
					resources: [...this.state.resources, ...resources],
					loading: false,
					pagination: pagination,
				});
			} else {
				this.setState({
					resources: resources,
					loading: false,
					pagination: pagination,
				});				
			}
		});
	};

	onLoadMore = () => {
		if (this.state.pagination.total_pages >= this.state.pagination.current_page) {
			this.setState(
				prevState => ({
					resource: {
						...prevState.event,
						page: this.state.resource.page + 1					
					}
				}), () => this.getFilteredResults()
			);
		}

		if (this.state.init_load_more) {
			this.init();
		}
	};

	renderLoadmore() {
		if (this.state.pagination.total_pages > this.state.pagination.current_page || this.state.init_load_more) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">						
						<button onClick={this.onLoadMore} className="btn btn-primary btn-lg">
							Load More <div className="loading-spinner">
							<BarLoader
								color={'#FFF'}
								loading={this.state.loading}
							/>
						</div></button>
					</div>
				</div>
			);	
		}
	};

	renderResults() {
		if (this.state.resources.length) {
			return (
				this.state.resources.map(resource => 
					<ResourceItem key={resource.id} resource={resource}/>
				)
			);
		}

		if (!this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<h1>No results found</h1>
					</div>
				</div>
			);			
		}
	}

	renderLoadStatus() {
		if (this.state.loading) {
			return (
				<div className="container">
					<div className="d-flex justify-content-center align-items-center py-4">
						<div className="loading-spinner">
							<PulseLoader
								color={'#28A2FB'}
								loading={this.state.loading}
							/>
						</div>
					</div>
				</div>
			);
		}
	}

	render() {
		return (
			<Fragment>
				<ResourceFilter 
					ref={this.resourceFilter}
					onClearFilter={this.onClearFilter} 
					onFilteredResults={this.onFilteredResults}
				/>

				<section id="tabResults" className="tab-results">
					{ this.renderResults() }
					{ this.renderLoadmore() }
					{ this.renderLoadStatus() }
				</section>
			</Fragment>
		)
	}
}

export default ResourceSearchList;